import React, { useEffect } from 'react'
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from 'react-router-dom';
import strings from '../../utils/locals/languages';
import { toast } from "react-toastify";
import { useSelector } from 'react-redux';
import { updateSectionClicks } from '../../services/updateAnalytics';

const Sections = () => {

    const globalData = useSelector((state) => state.globalData);
    const navigate = useNavigate()


    return (
        <div className="container mx-auto px-2 mb-3">
            {!globalData || globalData.sections.length === 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
                    {[1, 2, 3, 4, 5, 6].map((index) => (
                        <div
                            key={index}
                            className="cursor-pointer rounded-2xl shadow-md p-4 flex flex-col items-center bg-white"
                        >
                            <div className="w-full max-w-[250px] md:h-[80px] h-[160px]  rounded-lg overflow-hidden">
                                <Skeleton height="100%" width="100%" />
                            </div>
                            <div className="mt-2 w-full">
                                <Skeleton width="100%" height={20} />
                            </div>


                        </div>
                    ))}
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
                    {globalData.sections.map((item) => (
                        <div
                            key={item._id}
                            className="cursor-pointer rounded-2xl bg-white shadow-md p-4 flex flex-col items-center"
                            onClick={() => {
                                const validTitles = [
                                    "638f1fd34cb7c29ec6ad4bd6",
                                    "638f25154cb7c29ec6ad4bfe",
                                ];

                                if (validTitles.includes(item._id)) {
                                    updateSectionClicks(item._id);
                                    navigate(
                                        `${item._id === "638f1fd34cb7c29ec6ad4bd6" ? "/vehicle" : "/realstate"}`,
                                        { state: { id: item._id } }
                                    );
                                } else {
                                    toast.info(`${strings.comingSoon}`);
                                }
                            }}
                        >
                            <img
                                className="object-cover w-full max-w-[250px] md:h-[80px] h-[160px] rounded-lg"
                                src={item.imageUrl}
                                alt={item.title}
                            />
                            <h1 className="font-semibold text-sm md:text-base text-center mt-3 text-gray-700">
                                {item.title
                                    .split(" ")
                                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                    .join(" ")}
                            </h1>
                        </div>
                    ))}
                </div>
            )}
        </div>


    )
}

export default Sections